import api from '@/api';

const getters = {
  languages: state => state.languages || [],
};

export const mutations = {
  SET_LANGUAGES(state, { languages }) {
    state.languages = languages;
  },
};

const actions = {
  FETCH_LANGUAGES: ({ commit, state }) => {
    return new Promise(resolve => {
      if (state.languages) return resolve(state.languages);

      return api.fetchLanguages().then(languages => {
        commit('SET_LANGUAGES', { languages });
        resolve(languages);
      });
    });
  },
};

const state = {
  languages: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
